import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { class: "cy-notice-id title" };
const _hoisted_4 = { class: "option-ctrl-area" };
const _hoisted_5 = ["title"];
const _hoisted_6 = { class: "pb-3" };
const _hoisted_7 = { class: "py-3" };
const _hoisted_8 = { class: "py-3" };
const _hoisted_9 = { class: "py-3" };
const _hoisted_10 = { class: "pt-3 text-body wh-pl" };
const _hoisted_11 = { class: "py-3" };
import { onMounted, onUnmounted, computed, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import vuexStore from '@/vuex-store';
import { storeToRefs } from 'pinia';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { isTodayTextColor, formatDate, } from '@/utils';
import { enumProcessingType, enumProcessing, enumTargetType, enumType, } from '@/constants/memberCompanyInquiry/memberCompanyInquiryTableHeader';
import dateFormatType from '@/constants/dateFormatType';
import { alertActionType } from '@/vuex-store/alert/actions';
import { i18n } from '@/locales';
import { pStore } from '@/pinia';
import CardSection from '@/components/Common/CardSection.vue';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import { autoLcMemberCompanyInquiry } from '@/locales/ko/views/member_company_inquiry';
import CommentRow from './CommentRow.vue';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // Page: 회원사 업무문의 상세 조회
        const route = useRoute();
        const router = useRouter();
        const pMemberCompanyInquiry = pStore.piniaMemberCompanyInquiry;
        const { itemDetail, itemComments, } = storeToRefs(pMemberCompanyInquiry);
        const itemId = route.params.memberCompanyInquiryId;
        const lc = autoLcMemberCompanyInquiry();
        const userId = computed(() => vuexStore.getters['user/userId']);
        const _confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        /**
         * 목록보기 클릭 핸들러
         */
        const handleClickReturnBtn = () => {
            router.push({
                name: routeName.MEMBER_COMPANY_INQUIRY,
            }).catch(() => { });
        };
        /**
         * v-chip(typeClass)의 클래스 설정
         */
        const typeClass = computed(() => {
            const processingType = itemDetail.value.processingType || ''; // 안전하게 처리
            const cssClass = {};
            switch (processingType) {
                /** 접수 */
                case enumProcessing.RECEIVED:
                    cssClass['brg-color-blue-700'] = true;
                    break;
                /** 진행 */
                case enumProcessing.IN_PROGRESS:
                    cssClass['brg-color-orange-700'] = true;
                    break;
                /** 완료 */
                case enumProcessing.DONE:
                    cssClass['brg-color-green-700'] = true;
                    break;
                /** 반려 */
                case enumProcessing.REJECTED:
                    cssClass['brg-color-red-700'] = true;
                    break;
                /** 기등록벤 */
                case enumProcessing.ALREADY_ACCEPTED_VAN:
                    cssClass['brg-color-purple-700'] = true;
                    break;
                /** 제외 */
                case enumProcessing.NO:
                    cssClass['brg-color-grey-700'] = true;
                    break;
                default:
                    cssClass['brg-color-black'] = true;
                    break;
            }
            return cssClass;
        });
        onMounted(async () => {
            try {
                await pMemberCompanyInquiry.getItem(itemId);
            }
            catch (error) {
                console.log('e', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        });
        onUnmounted(() => {
            pMemberCompanyInquiry.clear();
        });
        /**
         * 삭제 핸들러
         */
        const handleClickDeleteBtn = async () => {
            const isConfirmOk = await _confirm({
                headerTitle: lc('delete_alert.head'),
                bodyContent: lc('delete_alert.body'),
            });
            if (!isConfirmOk) {
                return;
            }
            try {
                await pMemberCompanyInquiry.deleteItem(itemId);
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                router.push({
                    name: routeName.MEMBER_COMPANY_INQUIRY,
                });
            }
            catch (error) {
                console.log(error);
                vuexStore.dispatch(snackbarActionType.showSuccess);
            }
        };
        /**
         * 수정 핸들러
         */
        const handleClickEditBtn = () => {
            const name = routeName.MEMBER_COMPANY_INQUIRY_EDIT;
            const value = {
                params: {
                    itemId,
                },
                query: route.query,
            };
            router.push({
                name,
                ...value,
            }).catch(() => { });
        };
        return (_ctx, _cache) => {
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_data_table_server = _resolveComponent("v-data-table-server");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SubController),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(CardSection, null, {
                        titleContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(itemDetail).title), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(["cy-created-at item body2-text", _unref(isTodayTextColor)(_unref(itemDetail).createdAt)]),
                                    title: _unref(lc)('list.table.created_time')
                                }, _toDisplayString(_unref(formatDate)(_unref(itemDetail).createdAt, _unref(dateFormatType).FULL_DATE)), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
                            ])
                        ]),
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(lc)('user')) + " : " + _toDisplayString(_unref(itemDetail).createdByName) + "(" + _toDisplayString(_unref(itemDetail).createdBy) + ") ", 1 /* TEXT */),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(lc)('list.table.target_Type')) + " : " + _toDisplayString(_unref(enumTargetType)[_unref(itemDetail).targetType]), 1 /* TEXT */),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_8, [
                                _createTextVNode(_toDisplayString(_unref(lc)('list.table.processing_Type')) + " : ", 1 /* TEXT */),
                                _createElementVNode("span", null, [
                                    _createVNode(_component_v_chip, {
                                        class: _normalizeClass(typeClass.value)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(enumProcessingType)[_unref(itemDetail).processingType]), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["class"])
                                ])
                            ]),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(lc)('list.table.type')) + " : " + _toDisplayString(_unref(enumType)[_unref(itemDetail).type]), 1 /* TEXT */),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(itemDetail).body), 1 /* TEXT */),
                            _createVNode(_component_v_divider),
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(lc)('detail.comment')), 1 /* TEXT */),
                            _createElementVNode("div", null, [
                                _createVNode(_component_v_data_table_server, {
                                    "hide-default-header": "",
                                    "hide-default-footer": "",
                                    density: "comfortable",
                                    class: "brg-table brg-table-none-border",
                                    items: _unref(itemComments) || [],
                                    "items-length": -1
                                }, {
                                    [`item`]: _withCtx(({ item }) => [
                                        _createVNode(CommentRow, {
                                            item: item
                                        }, null, 8 /* PROPS */, ["item"])
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["items"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _createVNode(BoardFooter, null, {
                    left: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode(" mdi-chevron-left ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [0]
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.back_to_list')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                    ]),
                    right: _withCtx(() => [
                        (_unref(itemDetail).createdBy === userId.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createCommentVNode("삭제(본인작성만) "),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    class: "item",
                                    onClick: handleClickDeleteBtn
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { small: "" }, {
                                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                                _createTextVNode(" mdi-trash-can-outline ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [1]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(lc)('delete')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            danger: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ]),
                                _createCommentVNode("수정(본인작성만) "),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    class: "cy-edit-btn item",
                                    onClick: handleClickEditBtn
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { small: "" }, {
                                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                _createTextVNode(" mdi-pencil-outline ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [2]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(lc)('edit')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
